import React from "react";
import VIPPriority from "./VIPPriority";

export default function QueueVIP(props) {
  return (
    <div className="add-queue-root" >
      <VIPPriority 
        queue={props.queue} 
        setQueue={props.setQueue} 
        permissions={props.permissions} 
        isUpdate={props.isUpdate} 
      />
    </div>
  );
}
